import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBracketsCurly20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconBracketsCurly20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.554 2.683a.75.75 0 0 0 .684.803h.003l.043.007a2.05 2.05 0 0 1 .844.38c.436.333.988 1.035.988 2.597 0 1.798.661 2.895 1.476 3.527-.82.631-1.482 1.733-1.482 3.547 0 1.563-.55 2.26-.983 2.59a2 2 0 0 1-.84.373l-.042.006h-.003a.75.75 0 0 0 .111 1.496l-.051-.748.053.748h.009l.013-.002.018-.002.021-.002q.047-.005.12-.017a3.5 3.5 0 0 0 1.5-.66c.846-.644 1.574-1.805 1.574-3.782 0-1.55.593-2.183 1.063-2.473a2.2 2.2 0 0 1 1.016-.317h.01v-.75l.001.75a.75.75 0 0 0 .008-1.5l-.01.75.009-.75h-.011l-.055-.004a2.25 2.25 0 0 1-.963-.322c-.472-.294-1.062-.928-1.062-2.458 0-1.978-.73-3.142-1.576-3.789a3.55 3.55 0 0 0-1.5-.666 2 2 0 0 0-.159-.022l-.014-.001h-.005l-.002-.001h-.001c-.001 0-.002 0-.057.748l.056-.748a.75.75 0 0 0-.804.692m-3.108 0a.75.75 0 0 1-.684.803H7.76l-.043.007a2.05 2.05 0 0 0-.844.38c-.436.333-.988 1.035-.988 2.597 0 1.798-.661 2.895-1.476 3.527.82.631 1.482 1.733 1.482 3.547 0 1.563.55 2.26.983 2.589a2 2 0 0 0 .84.374l.042.006h.003a.75.75 0 0 1-.111 1.496l.051-.748c-.051.748-.052.748-.053.748h-.008l-.014-.002a2 2 0 0 1-.159-.021 3.5 3.5 0 0 1-1.5-.66c-.846-.644-1.574-1.805-1.574-3.782 0-1.55-.593-2.183-1.063-2.473a2.2 2.2 0 0 0-1.015-.317H2.3v-.75l-.008-.75h.011l.055-.004a2.25 2.25 0 0 0 .963-.322C3.794 8.634 4.384 8 4.384 6.47c0-1.978.73-3.142 1.576-3.789a3.55 3.55 0 0 1 1.5-.666 2 2 0 0 1 .159-.022l.014-.001h.005l.002-.001h.002l.056.748-.055-.748a.75.75 0 0 1 .803.692m-6.144 7.32-.002.75a.75.75 0 0 1-.008-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBracketsCurly20);
